module.exports = __webpack_public_path__ + "img/graduation-cap.6371e816.svg";